import { mapGetters } from 'vuex'

import { ACCOUNT_PERMISSIONS } from '@/store/account-permissions'

/**
 * `canManageBilling`: whether the signed-in member holds the billing permission.
 *
 * For the forms that call billing-only endpoints - payment methods, KYC, bank details - which
 * answer everyone else with a 403. They show BillingPermissionNotice instead of the form, and do not
 * call those endpoints.
 */
export default {
  computed: {
    ...mapGetters('auth', ['hasPermission']),

    canManageBilling() {
      return this.hasPermission(ACCOUNT_PERMISSIONS.BILLING)
    }
  }
}
